import React, { useContext } from 'react';
import logo from "../img/logo.png";
import "../css/Navbar.css";
import { Link, useNavigate } from 'react-router-dom';
import { LoginContext } from '../context/LoginContext';

export default function Navbar({ login }) {
  const navigate = useNavigate();
  const { setModalOpen } = useContext(LoginContext);
  const token = localStorage.getItem("jwt");
  const isLoggedIn = login || !!token;

  const loginStatus = () => {
    if (isLoggedIn) {
      return (
        <>
          <Link style={{ marginRight: "20px" }} to="/profile">
            <li>Profile</li>
          </Link>
          <button className='primaryBtn' onClick={() => setModalOpen(true)}>
            Log Out
          </button>
        </>
      );
    } else {
      return (
        <>
          <Link to="/signup" style={{ marginRight: "20px" }}>
            <li>SignUp</li>
          </Link>
          <Link to="/signin">
            <li>SignIn</li>
          </Link>
        </>
      );
    }
  };

  const loginStatusMobile = () => {
    if (isLoggedIn) {
      return (
        <>
          <Link to="/profile">
            <li><span className="material-symbols-outlined">account_circle</span></li>
          </Link>
          <button
            className='primaryBtn'
            style={{ padding: '8px 16px', fontSize: '13px' }}
            onClick={() => setModalOpen(true)}
          >
            Log Out
          </button>
        </>
      );
    } else {
      return (
        <>
          <Link to="/signup">
            <li>SignUp</li>
          </Link>
          <Link to="/signin">
            <li>SignIn</li>
          </Link>
        </>
      );
    }
  };

  return (
    <div className="navbar">
      <img
        id='linkalikes-logo'
        src={logo}
        alt="Logo"
        onClick={() => { navigate("/profile"); }}
        style={{ cursor: "pointer" }}
      />
      <ul className='nav-menu'>{loginStatus()}</ul>
      <ul className='nav-mobile' style={{ padding: '10px 20px', alignItems: 'center' }}>
        {loginStatusMobile()}
      </ul>
    </div>
  );
}
